import { render, staticRenderFns } from "./VendaMercado.vue?vue&type=template&id=5349d4fe"
import script from "./VendaMercado.vue?vue&type=script&lang=js"
export * from "./VendaMercado.vue?vue&type=script&lang=js"
import style0 from "./VendaMercado.vue?vue&type=style&index=0&id=5349d4fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports